import React from 'react';
import { describeLine, formatMoney } from './format';

// The lines of a bill — an invoice, a running estimate, or a preview — with
// the discount and total under them.
const LineItems = ({ bill, totalLabel = 'Total', compact = false }) => {
  const pad = compact ? 'py-1.5' : 'py-2.5';
  return (
    <table className="w-full text-sm">
      <thead className="sr-only">
        <tr>
          <th scope="col">Item</th>
          <th scope="col">Amount</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-700/60">
        {bill.lines.map((line) => (
          <tr key={line.code}>
            <td className={`${pad} pr-4`}>
              <span className="block text-gray-200">{line.label}</span>
              <span className="block text-xs text-gray-500">{describeLine(line)}</span>
            </td>
            <td className={`${pad} text-right text-gray-200 tabular-nums align-top`}>{formatMoney(line.amount_cents)}</td>
          </tr>
        ))}
        {bill.discount_cents > 0 && (
          <tr>
            <td className={`${pad} pr-4 text-gray-300`}>Discount ({bill.discount_percent}%)</td>
            <td className={`${pad} text-right text-emerald-300 tabular-nums`}>−{formatMoney(bill.discount_cents)}</td>
          </tr>
        )}
      </tbody>
      <tfoot>
        <tr className="border-t border-gray-600">
          <th scope="row" className={`${pad} pr-4 text-left font-semibold text-white`}>{totalLabel}</th>
          <td className={`${pad} text-right font-semibold text-white tabular-nums`}>{formatMoney(bill.total_cents)}</td>
        </tr>
      </tfoot>
    </table>
  );
};

export default LineItems;
